import React from "react";
import { motion } from "framer-motion";
import Fleet from "../components/Fleet";

const FleetPage = () => {
  return (
    <>
      <Fleet />
    </>
  );
};

export default FleetPage;
